(ns app.front.dashlets
  (:require [app.front.entities :as entities]
            [re-frame.core-instrumented :as rf]))

(defn remove-loading-flag [db dashlet-id]
  (assoc-in db [::dashlet-db dashlet-id :loading?] false))

(defn on-success-handler
  "Returns a handler that executes if result is success, taking
  parameters dashlet-id and response"
  [f]
  (fn [db [_ dashlet-id status response]]
    (if (= 200 status)
      (f db dashlet-id response)
      db)))

(rf/reg-event-db ::merge-dashlet-data
  (on-success-handler
    (fn [db dashlet-id response]
      (-> db
          (update-in [::dashlet-db dashlet-id :data] merge response)
          (remove-loading-flag dashlet-id)))))

(rf/reg-event-db ::assoc-dashlet-data
  (on-success-handler
    (fn [db dashlet-id response]
      (-> db
          (assoc-in [::dashlet-db dashlet-id :data] response)
          (remove-loading-flag dashlet-id)))))

(rf/reg-event-db ::delete-item
  (fn [db [_ dashlet-id item-id]]
    (update-in db [::dashlet-db dashlet-id :data] dissoc item-id)))

(rf/reg-sub ::dashlet-db
  :-> ::dashlet-db)

(rf/reg-sub ::dashlet
  :<- [::dashlet-db]
  (fn [dashlet-db [_ dashlet-id]]
    (let [dashlet (get dashlet-db dashlet-id)]
      (cond-> dashlet
        (nil? (:loading? dashlet)) (assoc :loading? true)))))

(rf/reg-sub ::dashlet-loading?
  (fn [[_ dashlet-id] _]
    (rf/subscribe [::dashlet dashlet-id]))
  :-> :loading?)

(rf/reg-sub ::dashlet-entity
  (fn [[_ dashlet-id]]
    [(rf/subscribe [::entities/schema])
     (rf/subscribe [::entities/components])
     (rf/subscribe [::dashlet dashlet-id])])
  (fn [[schema components dashlet] [_ _ xform]]
    (entities/find-entity {:schema schema :components components :entity-db (:data dashlet)} xform)))

(rf/reg-sub ::dashlet-entities
  (fn [[_ dashlet-id]]
    [(rf/subscribe [::entities/schema])
     (rf/subscribe [::entities/components])
     (rf/subscribe [::dashlet dashlet-id])])
  (fn [[schema components dashlet] [_ _ xform]]
    (entities/find-entities {:schema schema :components components :entity-db (:data dashlet)} xform)))
